export default __webpack_public_path__ + "static/919mexico-thumbnail-bbafee768b9b248f31098a41119d826d.png";